import { Table } from 'antd';
import { useSelector } from 'react-redux';
import useIsUiHidden from '../../hooks/dom/useIsUiHidden';
import { useState } from 'react';

const ProfTable = ({ ...props }) => {
  const isUiHidden = useIsUiHidden();
  const { informationExpanded } = useSelector(state => state.professionalReport);

  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(100);

  const handlePaginationChange = (newPage, newPageSize) => {
    setCurrent(newPage);
    setPageSize(newPageSize);
  };

  const pagination =
    !informationExpanded || isUiHidden
      ? props?.pagination
      : props?.pagination
      ? {
          current,
          pageSize,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
          onChange: handlePaginationChange,
        }
      : false;
  return <Table {...props} scroll={isUiHidden ? false : { x: 'max-content' }} pagination={pagination} />;
};

export default ProfTable;
